export const UEX = "https://www.unex.es/";
